export default "__VITE_ASSET__BkNXR2Rr__";